<template>
  <v-dialog v-model="isOpenSectionEditor" width="400" max-width="100vw" persistent>
    <v-card>
      <v-card-title class="title pa-4">
        {{ title }}
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4 overflow-y-auto" style="max-height: calc(100vh - 210px);">
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="payload.name"
              v-validate="'required'"
              :label="$t('sections.fields.name')"
              :data-vv-name="$t('sections.fields.name')"
              :error-messages="[...errors.collect($t('sections.fields.name')), ...(errorMessages.name || [])]"
              :readonly="loading || ['detail'].includes(sectionEditorMode)"
              @input="errorMessages.name = []"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="payload.description"
              v-validate="'max:250'"
              :label="$t('sections.fields.description')"
              :data-vv-name="$t('sections.fields.description')"
              :error-messages="[...errors.collect($t('sections.fields.description')), ...(errorMessages.description || [])]"
              :readonly="loading || ['detail'].includes(sectionEditorMode)"
              counter="250"
              no-resize
              rows="3"
              @input="errorMessages.description = []"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="payload.permissions"
              :items="actions"
              :readonly="loading || ['detail'].includes(sectionEditorMode)"
              :label="$t('sections.fields.permissions')"
              item-text="name"
              item-value="id"
              multiple
              chips
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="payload.is_admin"
              :label="$t('sections.fields.is_admin')"
              :readonly="loading || ['detail'].includes(sectionEditorMode)"
              hide-details
              class="ma-0 pa-0"
            ></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          @click="close()"
          :disabled="loading"
          color="primary"
          text
          width="120"
        >
          {{ $t('actions.cancel') }}
        </v-btn>
        <v-btn
          v-if="['detail'].includes(sectionEditorMode)"
          @click="setSectionEditorMode('edit')"
          :loading="loading"
          color="primary"
          width="120"
        >
          {{ $t('actions.edit') }}
        </v-btn>
        <v-btn
          v-else
          @click="submit()"
          :loading="loading"
          color="primary"
          width="120"
        >
          {{ $t('actions.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SectionEditor',
  data: () => ({
    loading: false,
    errorMessages: {},
    payload: {
      id: null,
      name: '',
      description: '',
      is_admin: false,
      permissions: []
    }
  }),
  computed: {
    ...mapGetters({
      isOpenSectionEditor: 'sections/isOpenSectionEditor',
      sectionEditorMode: 'sections/sectionEditorMode',
      section: 'sections/section',
      actions: 'actions/actions'
    }),
    title () {
      if (this.sectionEditorMode === 'create') {
        return 'Crear sección'
      }
      if (this.sectionEditorMode === 'detail') {
        return 'Detalle de sección'
      }
      return 'Editar sección'
    }
  },
  watch: {
    isOpenSectionEditor (newVal) {
      if (newVal) {
        this.loadDefault()
      }
    },
    section (newVal) {
      if (newVal.id) {
        this.setPayload(newVal)
      }
    }
  },
  created () {
    this.loadDefault()
  },
  destroyed () {
    this.resetActionState()
  },
  methods: {
    ...mapActions({
      resetActionState: 'actions/resetState',
      getActions: 'actions/getActions',
      saveSection: 'sections/saveSection',
      updateSection: 'sections/updateSection'
    }),
    ...mapMutations({
      toggleSectionEditor: 'sections/toggleSectionEditor',
      setSection: 'sections/setSection',
      setSectionEditorMode: 'sections/setSectionEditorMode'
    }),
    loadDefault () {
      this.getActions({ fields: 'id,name', limit: 'all', sort: 'id:asc' })
    },
    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }
      const {
        payload,
        sectionEditorMode,
        saveSection,
        updateSection
      } = this
      this.loading = true
      let result
      if (['create'].includes(sectionEditorMode)) {
        result = await saveSection(payload)
      } else {
        result = await updateSection(payload)
      }
      this.loading = false
      if (result.success) {
        this.close()
      } else {
        this.setErrorMessages(result.errors)
      }
    },
    setErrorMessages (errors) {
      errors.forEach(({ field, message, validation }) => {
        if (!this.errorMessages[field]) {
          this.errorMessages[field] = []
        }
        this.errorMessages[field].push(this.$t(`messages.validation_error.${validation}`, null, { field: this.$t(`sections.fields.${field}`) }))
      })
    },
    setPayload (payload) {
      const {
        id = null,
        name = '',
        description = '',
        is_admin = false,
        permissions = []
      } = payload
      this.payload = {
        id,
        name,
        description,
        is_admin,
        permissions: permissions.map(({ action_id }) => action_id)
      }
    },
    setDefaultData () {
      this.loading = false
      this.errorMessages = {}
      this.payload = {
        id: null,
        name: '',
        description: '',
        is_admin: false,
        permissions: []
      }
    },
    cleanData () {
      this.setDefaultData()
      this.setSection({})
      this.$validator.reset()
    },
    close () {
      this.toggleSectionEditor()
      this.cleanData()
    }
  }
}
</script>
